import { createSelector } from 'reselect'

import { RootState } from '~store/root.reducer'

const selectGlobalState = (state: RootState) => state.global

export const getAppData = createSelector(
  selectGlobalState,
  state => state.appData,
)

export const getAppStatus = createSelector(
  getAppData,
  appData => appData.appStatus,
)

export const getToastsToDisplay = createSelector(
  getAppData,
  appData => appData.toastsToBeDisplayed,
)

export const getBootstrapData = createSelector(
  selectGlobalState,
  state => state.bootstrapData,
)
